<script>
  import { format } from 'svelte-i18n';

  export let row = {};
</script>

<div class="campaigns">
  {#if row.campaigns.length}
    {#each row.campaigns as campaign}
      <div class="campaign" style="background-color: {campaign.color}">{campaign.label}</div>
    {/each}
  {:else}
    <div class="empty">{$format('label.NO_CAMPAIGNS')}</div>
  {/if}
</div>

<style lang="scss">
  .campaigns {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .empty,
  .campaign {
    align-items: center;
    background-color: var(--color-blue-500);
    border-radius: var(--border-radius-base);
    color: rgba(0, 0, 0, 0.4);
    display: inline-flex;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    white-space: nowrap;
  }

  .empty {
    background-color: var(--color-gray-200);
    color: var(--color-gray-600);
  }
</style>
